import React, { memo, useMemo } from 'react';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import EmptyScreen from 'components/EmptyScreen';
import { useWeb5Context } from 'lib/Web5Context';
import { emptyDashboardSvg, errorSvg } from 'lib/svgs';
import styles from './styles';

const useStyles = createUseStyles(styles, 'DashboardEmpty');

const Empty = memo(({ children, type, title, onRefresh }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const finalTitle = useMemo(() => {
        if (title) return title;
        if (type === 'empty') return t('label_no_widgets_found');
        if (type === 'emptyNoPermission') return t('label_no_widgets_found_short');
        return t('error_we_had_problem');
    }, [type, title, t]);

    const description = useMemo(() => {
        return t('label_forcebi_no_widgets_found_description');
    }, [t]);

    const illustration = useMemo(() => {
        if (type === 'empty') return emptyDashboardSvg;
        return errorSvg;
    }, [type]);

    return (
        <div className={classes.root}>
            <EmptyScreen
                title={finalTitle}
                description={description}
                illustration={illustration}
                overrides={{
                    root: {
                        style: {
                            marginTop: '0px',
                        },
                    },
                    emptyView: {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        },
                    },
                    illustration: {
                        style: {
                            width: type === 'empty' ? '200px' : '150px',
                            display: 'flex',
                            alignSelf: 'center',
                        },
                    },
                }}
            >
                {children}
                {onRefresh && (
                    <Button
                        className={classes.refresh}
                        type="secondary"
                        onClick={onRefresh}
                        onMouseDown={(e) => e?.stopPropagation()}
                    >
                        {t('action_refresh')}
                    </Button>
                )}
            </EmptyScreen>
        </div>
    );
});

export default Empty;
